import { createContext, useContext } from 'react';

const GdprContext = createContext({
    gdprActive: false,
    gdprConsented: true,
    gdprPlaceholder: '',
    gdprAvatarPlaceholder: '',
});

export const GdprProvider = GdprContext.Provider;

export const useGdpr = () => useContext(GdprContext);

export default GdprContext;
